<template>
  <a-layout class='index animated fadeIn'>
    <a-card class="m-t-10" :bordered='false'>
      <a-button size='small' @click="()=>{$router.go(-1)}">
        <LeftOutlined />返回
      </a-button>
      <span class="ml15 card_title">在线订单退款详情</span>
    </a-card>
    <div class="s_ptb0lr24 s_bf p-t-24">
      <div class="mb25">
        <!-- 退货退款 -->
        <a-steps :current="step" v-if="orderData.refund_type==1">
          <a-step title="买家申请退货退款" :sub-title="orderData.refund_time" />
          <a-step title="商家处理退款申请" />
          <a-step title="买家退货给商家" />
          <a-step title="商家处理退货商品" />
          <a-step title="退款成功" />
        </a-steps>
        <!-- 仅退款 -->
        <a-steps :current="step" v-if="orderData.refund_type==0">
          <a-step title="买家申请退款" :sub-title="orderData.refund_time" />
          <a-step title="商家处理退款申请" />
          <a-step title="退款成功" />
        </a-steps>
        <div class="s_p24">
          <p class="s_c333  s_lin_h35 s_fonts16"><span class="m-r-15 s_font_b">退款状态：{{orderData.refund_status_text}}</span><span>退款编号{{orderData.refund_sn}}</span>
          </p>
          <p v-if="orderData.remaining_time&&orderData.refund_status==0">
            收到买家{{orderData.refund_type==0?'退款':'退货退款'}}申请，请在 {{orderData.remaining_time}} 内尽快处理<br>
            如你逾期未处理，将自动同意申请，{{orderData.refund_type==0?'退款给买家':'并发送默认退货地址给买家'}}
          </p>
          <p v-if="orderData.remaining_time&&orderData.refund_status==1">
            商家已同意买家退货退款<br>
            如买家在 {{orderData.remaining_time}} 内未处理，退款申请将自动关闭
          </p>
          <p v-if="orderData.remaining_time&&orderData.refund_status==2">
            买家已退货，收到买家退货时，请验货后同意退款<br>
            如你在 {{orderData.remaining_time}} 内未处理，将自动确认收货并退款给买家
          </p>
          <p v-if="orderData.remaining_time&&(orderData.refund_status==7 || orderData.refund_status==8)">
            你已拒绝{{orderData.refund_status==7 ? '本次退款申请':'收货'}}，如买家修改退款申请后，需要你重新处理。<br>
            如买家在 {{orderData.remaining_time}} 内未响应，退款申请将自动关闭。
          </p>
          <!-- `refund_status`   '0:待审核（买家申请退货退款）1：审核通过（卖家同意退货退款）（等待买家发货） 2：买家已发货（等待卖家收货） 3：已收货（卖家已收货） 4：退货退款完成\r\n5：撤销申请 6：退款关闭 7：拒绝（退款/退货退款） 8：卖家拒绝收货', -->
          <div class="m-t-20" v-if="orderData.refund_status!=6">
            <a-button type="primary" class="m-r-10" v-if="(orderData.refund_status==0||orderData.refund_status==7||orderData.refund_status==8)&&orderData.refund_type==0" @click="agreeApply(1)">同意退款</a-button>
            <a-button type="danger" class="m-r-10" v-if="orderData.refund_status==0" @click="agreeApply(2)">拒绝买家{{orderData.refund_type==0?'退款':'退货退款'}}</a-button>
            <!-- 退货退款---------------------------- -->
            <a-button type="primary" class="m-r-10" v-if="(orderData.refund_status==0||orderData.refund_status==7)&&orderData.refund_type==1" @click="orderRefunds(1)">同意退货退款</a-button>
            <a-button type="primary" class="m-r-10" v-if="orderData.refund_status==2||orderData.refund_status==8" @click="agreeApply(1)">确认收货</a-button>
            <a-button type="danger" class="m-r-10" v-if="orderData.refund_status==2&&orderData.refund_type==1" @click="agreeApply(2)">拒绝收货</a-button>
          </div>
        </div>
      </div>
      <div class="mb25">
        <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333">退款申请信息</p>
        <div class="s_p24">
          <p class="s_c333  s_lin_h35">退款方式：{{orderData.refund_type==0?'仅退款':'退货退款'}}</p>
          <p class="s_c333  s_lin_h35">货物状态：{{orderData.refund_goods_status_text}}</p>
          <p class="s_c333  s_lin_h35">退款原因: {{orderData.refund_reason}}</p>
          <p class="s_c333  s_lin_h35">手机号码: {{orderData.contact_mobile}}</p>
        </div>
      </div>
      <div class="m-b-10">
        <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333">订单信息</p>
        <div class="s_p24">
          <p class="s_c333  s_lin_h35">买家信息: {{orderData.buyer_name}}</p>
          <p class="s_c333  s_lin_h35">订货单号：{{orderData.order_sn}}</p>
          <p class="s_c333  s_lin_h35">下单时间: {{orderData.add_time}}</p>
          <p class="s_c333  s_lin_h35">订单金额: {{orderData.pay_price}}积分</p>
          <p class="s_c333  s_lin_h35" v-if="orderData.delivery">物流公司: {{JSON.parse(orderData.delivery).express_name}}</p>
          <p class="s_c333  s_lin_h35" v-if="orderData.delivery">物流单号: {{JSON.parse(orderData.delivery).express_no}}</p>
          <p class="s_c333   s_flex_ali">退款商品： 
            <a-card-meta>
              <template #avatar>
                <img :src="info.picdomain+'/'+(orderData.goods_image)" alt="" style="width:50px">
              </template>
              <template #description>
                <p class="s_omit">{{orderData.goods_name}}</p>
                <p class="s_omit">{{orderData.goods_sku_name}} (退款积分:{{orderData.refund_point_price}}) <span style="color:#f04635;font-weight:600">({{orderData.refund_goods_status_text}})</span></p>
              </template>
            </a-card-meta>
          </p>
        </div>
      </div>
      <div class="mb25 m-t-10">
        <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333">协商记录</p>
        <div class="text-ar m-b-10 m-t-5">
          <a-button type="link" @click="sendMessage">发表留言</a-button>
        </div>
        <div class="s_ptb0lr24">
          <a-list class="comment-list" item-layout="horizontal" :data-source="orderData.refund_log">
            <template #renderItem="{ item }">
              <a-comment>
                <template #avatar>
                  {{item.role_type_text}}
                </template>
                <template #content>
                  <p>
                    留言:{{ item.remark }}
                  </p>
                  <p v-if="item.images">
                    <span class="m-r-5" v-for="(value,key) in item.images" :key="key">
                    <a-image :width="50"  :src="info.picdomain+value"  style="margin-right:5px"  />
                    </span>
                  </p>
                </template>
                <template #datetime>
                  {{item.add_time}}
                </template>
              </a-comment>
            </template>
          </a-list>
        </div>
      </div>
    </div>
    <a-modal title="退货地址" centered v-model:visible="showRefundList" :confirm-loading="confirmLoading" @ok="eidtRemarks" destroyOnClose>

    </a-modal>
    <a-modal :keyboard="false" title="退款" :width='600' centered :footer="null" v-model:visible="showRefunds" destroyOnClose>
      <refundPoup :refundsData='refundsData' type='list' v-on:submitrefunds='submitrefunds'></refundPoup>
    </a-modal>
  </a-layout>
</template>

<script>
import { LeftOutlined } from "@ant-design/icons-vue";
import { ref, onMounted, inject, reactive, toRefs, createVNode, h } from "vue";
import { message, Modal, Input } from "ant-design-vue";
import refundPoup from "./refundPoup.vue";
import store from "@/store";
import {
  channelOrderRemarkUpdate,
  getChannelRefundDetail,
  getChannelRefundAudit,
  sendChannelRefundMessage,
  getChannelRefund,
} from "@/api/order";
import { iscode } from "@/utils/app";
export default {
  components: {
    LeftOutlined,
    refundPoup,
  },
  setup() {
    const state = reactive({
      step: 1, //退款进度
      showAddress: false,
      showRefunds: false,
      showDeliver: false,
      listLoading: false,
      showRefundList: false,
      addressData: {},
      deliverData: {},
      refundsData: {},
      orderRemarks: "",
      deliverType: 1,
      confirmLoading: false,
      info: store.state.user.info,
      orderData: {},
      allNum: 0,
      allWeight: 0,
    });
    let columnsGood = [
      {
        title: "商品",
        key: "good",
        slots: { customRender: "good" },
      },
      {
        title: "规格",
        dataIndex: "goods_sku_name",
        key: "goods_sku_name",
      },
      {
        title: "数量",
        dataIndex: "goods_num",
        key: "goods_num",
      },
      {
        title: "单价（积分）",
        dataIndex: "point_price",
        key: "point_price",
      },
      {
        title: "小计（积分）",
        dataIndex: "total_point_price",
        key: "total_point_price",
      },
      {
        title: "发货状态",
        dataIndex: "order_status_text",
        key: "order_status_text",
      },
      {
        title: "退款状态",
        dataIndex: "status_text",
        key: "status_text",
      },
    ];
    let columnsRecord = [
      {
        title: "操作时间",
        dataIndex: "create_time",
        key: "create_time",
      },
      {
        title: "操作人",
        dataIndex: "user",
        key: "user",
        slots: { customRender: "user" },
      },
      {
        title: "操作动作",
        dataIndex: "type",
        key: "type",
      },
      {
        title: "信息",
        dataIndex: "remark",
        key: "remark",
      },
    ];
    const $route = inject("$route");
    //打开退货弹窗
    const orderRefunds = () => {
      state.refundsData = {
        ...state.orderData,
        refund_id: $route.query.refund_id,
      };
      state.showRefunds = true;
    };
    //退货
    const submitrefunds = () => {
      state.showRefunds = false;
      initData();
    };

    //获取详情
    const initData = async () => {
      const hide = message.loading("正在加载中...", 0);
      let res = await getChannelRefundDetail({
        refund_id: $route.query.refund_id,
      }).then((res) => res.data);
      state.listLoading = false;
      if (iscode(res)) {
        state.orderData = res.data;
        // refund_status`   '0:待审核（买家申请退货退款）1：审核通过（卖家同意退货退款）（等待买家发货） 2：买家已发货（等待卖家收货） 3：已收货（卖家已收货） 4：退货退款完成\r\n5：撤销申请 6：退款关闭 7：拒绝（退款/退货退款） 8：卖家拒绝收货',
       // 退货退款
        if (state.orderData.refund_type == 1) {
          // 退货退款完成
          if (state.orderData.refund_status == 4) {
            state.step = 5;
          }
          if (state.orderData.refund_status == 2||state.orderData.refund_status == 8) {
            state.step = 3;
          }
        }
         // 仅退款
        if (state.orderData.refund_type == 0) {
          if (state.orderData.refund_status == 4) {
            state.step = 2;
          }
       
     
        }
      } else {
        message.error(res.msg);
      }

      setTimeout(hide);
    };
    onMounted(() => {
      initData();
    });

    // 退款处理
    const agreeApply = (status) => {
      // 同意
      if (status == 1) {
        Modal.confirm({
          centered: true,
          title: "同意退款",
          content: h("div", {}, [
            h(
              "p",
              `退款方式：${
                state.orderData.refund_type == 0 ? "退款" : "退货退款"
              }`
            ),
            h("p", `退还积分：${state.orderData.refund_point_price}`),
          ]),
          onOk: async () => {
            let res = await getChannelRefund({
              refund_id: $route.query.refund_id,
              refund_type: 1,
              remark: "",
            }).then((res) => res.data);
            if (iscode(res, true)) {
              initData();
            }
          },
        });
      } else {
        var remark = "";
        Modal.confirm({
          centered: true,
          title: state.orderData.refund_type == 0 ? "拒绝退款" : "拒绝退货退款",
          content: h("div", {}, [
            h(
              "p",
              `退款方式：${
                state.orderData.refund_type == 0 ? "仅退款" : "退货退款"
              }`
            ),
            h("p", `退货数量：${state.orderData.goods_num}`),
            h("p", `退还积分：${state.orderData.refund_point_price}`),
            h("p", {}, [
              "拒绝原因",
              h(Input.TextArea, {
                "on-blur": function (e) {
                  remark = e.target.value;
                },
              }),
            ]),
          ]),
          onOk: async () => {
            if (!remark) {
              message.error("请输入拒绝原因");
              return new Promise().reject();
            }
            var res;
            // 拒绝
            if (
              state.orderData.refund_type == 1 &&
              state.orderData.refund_status == 0
            ) {
              res = await getChannelRefundAudit({
                refund_id: $route.query.refund_id,
                refund_type: 2,
                remark: remark,
              }).then((res) => res.data);
            } else {
              res = await getChannelRefund({
                refund_id: $route.query.refund_id,
                refund_type: 2,
                remark: remark,
              }).then((res) => res.data);
            }

            if (iscode(res, true)) {
              initData();
            }
          },
        });
      }
    };
    //发表留言
    const sendMessage = () => {
      var remark = "";
      Modal.confirm({
        centered: true,
        content: h("div", {}, [
          h("p", {}, [
            "留言",
            h(Input.TextArea, {
              "on-blur": function (e) {
                remark = e.target.value;
              },
            }),
          ]),
        ]),
        onOk: async () => {
          if (!remark) {
            message.error("请输入留言");
            return new Promise().reject();
          }
          let res = await sendChannelRefundMessage({
            refund_id: $route.query.refund_id,
            remark: remark,
          }).then((res) => res.data);
          if (iscode(res, true)) {
            initData();
          }
        },
      });
    };
    return {
      columnsRecord,
      columnsGood,
      ...toRefs(state),
      info: store.state.user.info,
      orderRefunds,
      submitrefunds,
      agreeApply,
      sendMessage,
    };
  },
};
</script>

